import Vue from 'vue'
import Router from 'vue-router'
import TheHomeNav from '@/components/home/Nav'
import TheHome from '@/components/home/Home'
import TheHomeVideo from '@/components/home/Video'
import TheHomeContest from '@/components/home/Contest'
import TheHomeStudio from '@/components/home/Studio'
import TheHomeDancer from '@/components/home/Dancer'
import TheHomeInfo from '@/components/home/Info'
import TheVideo from '@/components/video/Detail'
import TheContest from '@/components/contest/Detail'
import TheDancer from '@/components/dancer/Detail'
import TheDancerVideo from '@/components/dancer/Video'
import TheDancerActivity from '@/components/dancer/Activity'
import TheDancerActivityDetail from '@/components/dancer/ActivityDetail'
import TheStudio from '@/components/studio/Detail'
import TheStudioVideo from '@/components/studio/Video'
import TheStudioDancer from '@/components/studio/Dancer'
import TheStudioStore from '@/components/studio/Store'
import TheStudioInfo from '@/components/studio/Info'
import TheStore from '@/components/store/Detail'
import TheInfo from '@/components/info/Detail'
import TheUserPrivacyPolicy from '@/components/user-privacy/index'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: TheHomeNav,
      children: [
        {
          name: 'home',
          path: '',
          component: TheHome
        },
        {
          name: 'homeVideos',
          path: 'videos',
          component: TheHomeVideo
        },
        {
          name: 'homeContests',
          path: 'contests',
          component: TheHomeContest
        },
        {
          name: 'homeStudios',
          path: 'studios',
          component: TheHomeStudio
        },
        {
          name: 'homeDancers',
          path: 'dancers',
          component: TheHomeDancer
        },
        {
          name: 'homeInfo',
          path: 'info',
          component: TheHomeInfo
        },
      ],
    },
    // 视频详情页
    {
      name: 'videos',
      path: '/videos/:id(\\d+)',// 可选, 且只匹配数字
      component: TheVideo,
    },
    // 赛事详情页
    {
      name: 'contests',
      path: '/contests/:id(\\d+)',// 可选, 且只匹配数字
      component: TheContest,
    },
    {
      path: '/dancers/:id(\\d+)',// 可选, 且只匹配数字
      component: TheDancer,
      children: [
        {
          name: 'dancersVideos',
          path: '',// 可选, 且只匹配数字
          component: TheDancerVideo,
        },
        {
          name: 'dancersActivities',
          path: 'activities',// 可选, 且只匹配数字
          component: TheDancerActivity,
        },
      ]
    },
    {
      name: 'activities',
      path: '/dancers/activities/:id(\\d+)',// 可选, 且只匹配数字
      component: TheDancerActivityDetail,
    },
    {
      path: '/studios/:id(\\d+)',// 可选, 且只匹配数字
      component: TheStudio,
      children: [
        {
          name: 'studiosVideos',
          path: '',// 可选, 且只匹配数字
          component: TheStudioVideo,
        },
        {
          name: 'studiosDancers',
          path: 'dancers',// 可选, 且只匹配数字
          component: TheStudioDancer,
        },
        {
          name: 'studiosStores',
          path: 'stores',// 可选, 且只匹配数字
          component: TheStudioStore,
        },
        {
          name: 'studiosInfo',
          path: 'info',// 可选, 且只匹配数字
          component: TheStudioInfo,
        },
      ]
    },
    {
      name: 'stores',
      path: '/stores/:id(\\d+)',// 可选, 且只匹配数字
      component: TheStore,
    },
    {
      name: 'info',
      path: '/info/:id(\\d+)',// 可选, 且只匹配数字
      component: TheInfo,
    },
    // 用户隐私政策
    {
      path: '/user-privacy-policies',
      component: TheUserPrivacyPolicy,
    },
    // 所有匹配不到的路由 都重定向至首页
    {
      path: '*',
      redirect: '/',
    },
  ],
  // 模拟原生浏览器回到顶部
  scrollBehavior: (to, from, savedPosition) => savedPosition ? savedPosition : {x: 0, y: 0},
})



// WEBPACK FOOTER //
// ./src/router/index.js